<!-- 上班时长 选择天数弹窗 -->
<template>
  <div>
    <el-dialog
      title="输入天数"
      width="800px"
      :visible.sync="visiable"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="()=>{handleBeforeClose();$emit('cancel')}"
    >

      <el-row>
        <el-col>
          请输入工天数
        </el-col>
        <el-col style="margin:18px 0 29px">
          <el-input style="width:450px" v-model="curDay" placeholder="请输入工天数" @input="Mixin_commonLimitInput('curDay',2,1,true)"></el-input>
        </el-col>
        <el-col>
          快速选择工天数
        </el-col>
        <el-col style="margin:18px 0 40px">
          <el-radio-group v-model="curDay">
            <el-radio border v-for="(item,index) in list" :key="index" :label="item">{{ item }}工</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="handleBeforeClose();$emit('cancel')">取消</el-button>
        <el-button @click="save" type="primary" style="margin-left:20px">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {wokerForm} from '@/mixins/validate/work.js'

export default {
  name: "workDaySelect",
  mixins: [wokerForm],
  props: {
    visiable: {
      type: Boolean
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      list: ["0.2", "0.5", "0.8", "1.5", "2"],
      curDay: ""
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit("update:visiable", false)
    },
    save() {
      this.$emit("update:value", this.curDay)
      this.$emit("save")
      this.handleBeforeClose()
    }
  },
  watch: {
    visiable() {
      this.curDay = isNaN(this.value) ? "" : String(this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}


/deep/ .el-radio{
  margin-right: 10px;
  height: 34px !important;
  padding: 9px 20px 0 10px !important;
}
/deep/.el-radio.is-bordered.is-checked{
  color: #0286df;
  border-color: #0286df;
  span {
    color: #0286df;
  }
}
/deep/ .el-dialog__footer{
  padding-top: 0;
  padding-bottom: 40px;
}
/deep/.el-dialog__body{
  padding-bottom: 0;
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
/deep/ .el-input__inner{
  height: 34px;
}
</style>
